import React, {useEffect, useState} from 'react'
import CandidateDashboardNav from '../../candidate/CandidateDashboardNav'
import axios from "axios";
import {Link} from "react-router-dom";
import Breadcrumb from '../../Breadcrumb';

const formatter = new Intl.DateTimeFormat("en-US",{
  dateStyle: "medium",
});

const AppliedJobs = () => {
  const [appliedJobs, setAppliedJobs] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const totalPages = Math.ceil(appliedJobs.length / pageSize);


  const paginatedAppliedJobs = appliedJobs.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('userid');
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `job_application/applied-jobs/${token}`);
        setAppliedJobs(response.data);
      }
      catch (error) {
        console.log(error);
      }
    }
    fetchData();

  }, []);
  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Applied Jobs</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Applied Jobs</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Applied Jobs"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Applied Jobs", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <CandidateDashboardNav />
            {/* here page will is design */}
            <div className="col-lg-9">
              <div className="user-profile-card">
                <div className="user-profile-card-header">
                  <h4 className="user-profile-card-title">Applied Jobs</h4>
                  <div className="user-profile-card-header-right">
                    <div className="user-profile-sort">
                      <form action="#">
                        <div className="form-group">
                          <select className="select">
                            <option value="1">Last 1 Month</option>
                            <option value="2">Last 2 Months</option>
                            <option value="3">Last 3 Months</option>
                            <option value="4">Last 6 Months</option>
                            <option value="5">Last 1 Year</option>
                          </select>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="table-responsive profile-applied-job">
                  <table className="table text-nowrap">
                    <thead>
                      <tr>
                        <th>Job Info</th>
                        <th>Applied Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {paginatedAppliedJobs.length > 0 ? (
                        paginatedAppliedJobs.map(job => (
                          <tr key={job.id}>
                            <td>
                              <div className="profile-job-content">
                                <h6><a href="#">{job.role}</a></h6>
                                <ul className="profile-job-list">
                                  <li>
                                    <i className="far fa-briefcase"></i> {job.industry}
                                  </li>
                                  <li>
                                    <i className="far fa-location-dot"></i> {job.city ? job.city : "Not Available"}
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td>{formatter.format(new Date(job.created_on))}</td>
                            <td><span
                              className={job.isactive === 1 ? "badge badge-success" : "badge badge-danger"}>Active</span>
                            </td>
                            <td>
                              <Link className="theme-btn" to={`/job-details/${job.job_id}`}>
                                View details
                              </Link>
                              {/* <a href="#" className="btn btn-outline-danger btn-sm"
                              ><i className="far fa-trash-can"></i
                              ></a> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan="4" >No Applied jobs available.</td>
                        </tr>
                      )
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pagination-area">
        <div className="pagination-area mt-4">
          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <a
                  className="page-link prev"
                  href="#"
                  tabIndex="-1"
                  onClick={(event) => {
                    event.preventDefault();
                    handlePageChange(currentPage - 1)
                  }}
                >
                  Previous
                </a>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      handlePageChange(index + 1)
                    }}
                  >
                    {index + 1}
                  </a>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <a
                  className="page-link next"
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    handlePageChange(currentPage + 1)
                  }}
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  )
}

export default AppliedJobs
